import { render, staticRenderFns } from "./dashboard-calendar.vue?vue&type=template&id=6db9bfdc"
import script from "./dashboard-calendar.vue?vue&type=script&lang=js"
export * from "./dashboard-calendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports